/**
 * Base Entity
 */
export default class Base {
  constructor(name) {
    this.class = name
  }

  toJson() {
    let obj = {}
    Object.entries(this).forEach(val => {
      obj[val[0]] = val[1]
    })

    return obj
  }

  toString() {
    return JSON.stringify(this.toJson())
  }

  static parse(target) {
    let json = {}

    if (target instanceof Object || target instanceof Array) {
      json = target
    } else {
      json = JSON.parse(target)
    }

    if (json instanceof Array) {
      return this.parseArray(json)
    }

    return new this(json)
  }

  static parseArray(entities) {
    let results = []

    entities.forEach(entity => {
      results.push(new this(entity))
    })

    return results
  }
}
